import React from 'react';
import { Plus } from 'lucide-react';
import TaskForm from './TaskForm';

const TaskFormWrapper = ({ 
  showTaskForm, 
  setShowTaskForm, 
  apiDepartments, 
  apiTeam, 
  selectedProject, 
  apiProjects, 
  createTask 
}) => {
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 my-4">
      {/* Add Task Button */}
      {!showTaskForm ? (
        <div className="flex justify-end">
          <button 
            className="bg-green-600 text-white px-4 py-2 rounded-lg shadow-sm flex items-center transition-all duration-200 hover:bg-green-700"
            onClick={() => setShowTaskForm(true)}
          >
            <Plus size={18} className="mr-2" />
            Add Task
          </button>
        </div>
      ) : (
        <TaskForm 
          departments={apiDepartments}
          teamMembers={apiTeam}
          selectedProject={selectedProject}
          projectsData={apiProjects}
          onCreateTask={createTask}
          onCancel={() => setShowTaskForm(false)}
        />
      )}
    </div>
  );
};

export default TaskFormWrapper;
